var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVariantti(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    fill: "#000000",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(13.729)",
    x: 14.419,
    y: -0.54175,
    width: 1,
    height: 9,
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(25.71)",
    x: 10.68,
    y: 5.4565,
    width: 6,
    height: 1,
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-25.224)",
    x: -3.5186,
    y: 16.134,
    width: 10,
    height: 1,
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(36.826)",
    x: 17.002,
    y: 2.0261,
    width: 9,
    height: 1,
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-33.086)",
    x: 3.1455,
    y: 16.81,
    width: 8,
    height: 1,
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 2.5,
    fill: "#990004"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 18,
    r: 1.5,
    fill: "#ff1a1f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 16.5,
    r: 1.5,
    fill: "#ff1a1f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 10,
    r: 1.5,
    fill: "#ff1a1f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 3.5,
    r: 1.5,
    fill: "#ff1a1f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 8,
    r: 2,
    fill: "#ff1a1f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariantti);
export default __webpack_public_path__ + "static/media/variantti.fd2d136d8394c5b04d227f860a34a390.svg";
export { ForwardRef as ReactComponent };